export const REGISTER_ACTION = 'REGISTER_ACTION';
export const CLEAR_REGISTER_STATE_ACTION = 'CLEAR_REGISTER_STATE_ACTION';
